import React, { useEffect, useState } from "react";
import axios from "axios";


const ConditionText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const lines = text?.split("\n") || [];
  const preview = lines.slice(0, 3).join("\n");
  const hasMore = lines.length > 3;

  return (
    <div style={{ fontSize: 11.5, color: "#5a6070", lineHeight: 1.65, whiteSpace: "pre-line" }}>
      {expanded ? text : preview}
      {hasMore && (
        <button
          onClick={() => setExpanded((e) => !e)}
          style={{
            display: "block",
            marginTop: 4,
            background: "none",
            border: "none",
            color: "#1a9e78",
            fontSize: 11,
            cursor: "pointer",
            padding: 0,
          }}
        >
          {expanded ? "Show less ▲" : "Show more ▼"}
        </button>
      )}
    </div>
  );
};

const KebabMenu = ({ cardId }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px 6px",
          borderRadius: 4,
          color: "#8a909e",
          fontSize: 18,
        }}
      >
        ⋮
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "100%",
            background: "#fff",
            border: "0.5px solid #e2e4e8",
            borderRadius: 8,
            zIndex: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,.08)",
            minWidth: 140,
          }}
        >
          {["Edit", "Duplicate", "Delete"].map((action) => (
            <div
              key={action}
              onClick={() => setOpen(false)}
              style={{
                padding: "9px 14px",
                fontSize: 12,
                color: action === "Delete" ? "#e24b4a" : "#1a1e2e",
                cursor: "pointer",
              }}
            >
              {action}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const RiskTriggerTable = ({ search = "", refreshKey, selectedMachine }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCards();
  }, [refreshKey, selectedMachine]); 

  const fetchCards = async () => {
    try {
      setLoading(true);

      // 👇 Pass machine as query param if selected
      const url = selectedMachine
        ? `https://api.hanoch.in/performance/action-cards/?machine=${selectedMachine}`
        : `https://api.hanoch.in/performance/action-cards/`;

      const res = await axios.get(url);

      const formatted = res.map((item) => ({
        id: item.id,
        machine: item.machine,
        cardName: item.cardname,
        condition: item.condition,
        equipment: item.equipment,
      }));

      setCards(formatted);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  // 🔹 Search filter
  const filtered = cards.filter(
    (c) =>
      !search ||
      c.cardName?.toLowerCase().includes(search.toLowerCase()) ||
      c.vessel?.toLowerCase().includes(search.toLowerCase()) ||
      c.equipment?.toLowerCase().includes(search.toLowerCase())
  );

  const COL = {
    vessel: "22%",
    cardName: "22%",
    condition: "42%",
    equipment: "10%",
    action: "4%",
  };

  return (
    <div
      style={{
        background: "#fff",
        border: "0.5px solid #e2e4e8",
        borderRadius: 10,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `${COL.vessel} ${COL.cardName} ${COL.condition} ${COL.equipment} ${COL.action}`,
          padding: "10px 16px",
          borderBottom: "0.5px solid #e2e4e8",
          background: "#f5f6f8",
        }}
      >
        {["Machine", "Card Name", "Condition", "Sub Equipment", ""].map(
          (h, i) => (
            <div
              key={i}
              style={{ fontSize: 12, fontWeight: 500, color: "#8a909e" }}
            >
              {h}
            </div>
          )
        )}
      </div>

      {/* Body */}
      {loading ? (
        <div style={{ padding: 30, textAlign: "center" }}>
          Loading...
        </div>
      ) : filtered.length === 0 ? (
        <div
          style={{
            padding: "40px 16px",
            textAlign: "center",
            color: "#aab0be",
          }}
        >
          No trigger cards found
        </div>
      ) : (
        filtered.map((card, idx) => (
          <div
            key={card.id}
            style={{
              display: "grid",
              gridTemplateColumns: `${COL.vessel} ${COL.cardName} ${COL.condition} ${COL.equipment} ${COL.action}`,
              padding: "14px 16px",
              borderBottom:
                idx < filtered.length - 1
                  ? "0.5px solid #e2e4e8"
                  : "none",
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 500 }}>
              {card.machine}
            </div>

            <div style={{ fontSize: 12 }}>{card.cardName}</div>

            <div>
              <ConditionText text={card.condition} />
            </div>

            <div style={{ fontSize: 11 }}>{card.equipment}</div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <KebabMenu cardId={card.id} />
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default RiskTriggerTable;